import React from 'react';
import CollectionPreferences from '@amzn/awsui-components-react/polaris/collection-preferences';
import { useTranslation } from 'react-i18next';
import { usePageSizePreference } from '../../hooks/tablePaginationPreference';
import { publishKatalMetric } from '../katalAnalytics';
import { COORDINATOR_EVENT_SHIFTS_TABLE } from '../../utils/constants';

export const DEFAULT_COORDINATOR_SHIFT_PAGE_SIZE = 10;

export interface CoordinatorShiftsPaginationPreferencesProps {
  pageSize?: number;
  resetDetailShifts?: (newPageSize: number) => void;
}

export function CoordinatorShiftsPaginationPreferences({
  pageSize,
  resetDetailShifts,
}: CoordinatorShiftsPaginationPreferencesProps) {
  const { t } = useTranslation(['activity', 'translation']);
  return (
    <CollectionPreferences
      onConfirm={({ detail }) => {
        const pageSize =
          detail.pageSize !== undefined ? detail.pageSize : DEFAULT_COORDINATOR_SHIFT_PAGE_SIZE;
        if (resetDetailShifts) {
          resetDetailShifts(pageSize);
        }

        publishKatalMetric(
          COORDINATOR_EVENT_SHIFTS_TABLE + '_paginationPreference_PageSizeChange',
          pageSize.toString()
        );
      }}
      preferences={{ pageSize: pageSize }}
      pageSizePreference={usePageSizePreference(
        {
          pageSizeTitleKey: 'coordinatorEventShiftsTable.paginationPreference.pageSizeTitle',
          pageCountKey: 'coordinatorEventShiftsTable.paginationPreference.shiftCount',
        },
        [5, 10, 25, 50],
        ['activity', 'translation']
      )}
      confirmLabel={t('coordinatorEventShiftsTable.paginationPreference.confirm')}
      cancelLabel={t('coordinatorEventShiftsTable.paginationPreference.cancel')}
      title={t('coordinatorEventShiftsTable.paginationPreference.title')}
    />
  );
}
